import extend from "lodash/extend";
import forEach from "lodash/forEach";
import keys from "lodash/keys";
import isArray from "lodash/isArray";
import Emitter from "emmett";

class Dispatcher {

    constructor() {
        this.emitter = new Emitter();
        this.registeredActionsKeys = [];
    }

    register(actions, options) {
        if (!isArray(actions)) {
            actions = [actions];
        }

        forEach(actions, (action) => {
            // action registration should be unnecessary when actions are all registered by the top-level views in Mobx
            let actionKey = action.actionsKey && action.actionsKey();
            if (actionKey && this.registeredActionsKeys.indexOf(actionKey) >= 0) {
                return;
            }

            if (options && options.autoBind === false) {
                this.emitter.on(action.events());
            } else {
                // bind the dispatcher to action if it allows it
                if (action.onBind) {
                    action.onBind(this);
                }
                this.registerEvents(action);
            }

            if (actionKey) {
                this.registeredActionsKeys.push(actionKey);
            }
        });
    }

    registerEvents(action) {
        let events = action.events();
        let eventNames = keys(events);
        // Auto-bind event handlers to the action class that owns them.
        forEach(eventNames, eventName => {
            let handler = events[eventName];
            if (handler) {
                this.emitter.on(eventName, handler.bind(action));
            } else {
                console.warn("Handler not defined for " + eventName);
            }
        });
    }

    emit(eventName, data) {
        this.emitter.emit(eventName, extend({ dispatcher: this }, data));
    }
}

export default Dispatcher;
